import * as React from 'react';
import { SVGProps } from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
const RestartVideoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 55"
    fill="none"
  >
    <path
      fillRule="evenodd"
      d="m27.832 42.973.305-.975c.688-2.205-1.268-4.328-3.521-3.822l-10.985 2.466c-2.253.505-3.114 3.261-1.55 4.96l7.629 8.28c1.564 1.698 4.381 1.066 5.07-1.138l.86-2.752a25 25 0 1 0-17.018-6.104l4.458-5.142a18.195 18.195 0 1 1 14.752 4.227Z"
      clipRule="evenodd"
    />
  </svg>
);
export default RestartVideoIcon;
